import { ProgressBar } from "primereact/progressbar";
import { ZT } from "./ZeroTrustData";
import { Button } from "primereact/button";
import TagAttack from "../MITREAttack/TagAttack";

export default function PhaseElement(props:any){
    const phaseId = props.phase;
    const ctrs = ZT.phaseOrder[phaseId].filter((ctr:String) => ctr[0] === props.p);
    
    return(
        <div className={`col-2 ztp-${phaseId}`}>
            {ctrs.map((ctr:any) => {
                const value = props.actions.metrics.controls?.[ctr] * 100 || 0;
                const ztKey = 'zt-' + ctr;
                const name = ZT.controls[ztKey].name;
                return(
                    <div key={`zt-${ctr}`} className='zt-card' style={{width: '100px'}}>
                        <TagAttack value={ZT.prevalence?.[ctr]?.norm || 0} />
                        <Button className='zt-btn' size='small' label={ctr} outlined style={{width: '100%'}} onClick={() => props.dispatch({type: 'setPopup', payload: ctr})}/>
                        <ProgressBar className='zt-prgb' value={value} showValue={false} color='green'/>
                    </div>
                )
            })}
        </div>
    )
}